import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * バッジの土台。状態表示は必ず StatusBadge を使う（P02）。
 * ここはタグなど、状態以外の短いラベル向け。
 */
const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-control px-2 text-note whitespace-nowrap',
  {
    variants: {
      variant: {
        default: 'border border-border-strong bg-background text-foreground-muted',
        solid: 'bg-primary text-primary-foreground',
        muted: 'bg-muted text-foreground-muted',
        /** 破線＝進行中・未確定 */
        dashed: 'border border-dashed border-border-strong bg-background text-foreground-muted',
      },
      size: { default: 'h-6', lg: 'h-7' },
    },
    defaultVariants: { variant: 'default', size: 'default' },
  },
);

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>;

export const Badge = ({ className, variant, size, ...props }: BadgeProps) => (
  <span className={cn(badgeVariants({ variant, size }), className)} {...props} />
);

export { badgeVariants };
